(function () {
  var drawer = document.querySelector('[data-byo-drawer]');
  if (!drawer) return;

  function openDrawer() {
    drawer.setAttribute('data-open', '');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.removeAttribute('data-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Close via backdrop or the X button
  drawer.querySelectorAll('[data-byo-drawer-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  // Close automatically when a nav link is tapped (so navigation isn't blocked visually)
  drawer.querySelectorAll('.byo-drawer__link, .byo-drawer__trending-card').forEach(function (el) {
    el.addEventListener('click', function () {
      // allow the click/navigation to proceed; just also close the drawer
      closeDrawer();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // Intercept Horizon's native hamburger button (the real trigger for its own
  // drawer) and redirect it to open ours instead — using capture phase so we
  // run before the native handler, and stopImmediatePropagation to prevent
  // the native <details> element from also toggling open underneath ours.
  var nativeToggle = document.querySelector('.menu-drawer-container > summary.header__icon--summary');
  if (nativeToggle) {
    nativeToggle.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openDrawer();
      },
      true // capture phase — runs before native listeners
    );
  } else {
    // Fallback: if the native button couldn't be found (theme markup changed),
    // try again shortly in case it wasn't in the DOM yet at script load time.
    setTimeout(function () {
      var retryToggle = document.querySelector('.menu-drawer-container > summary.header__icon--summary');
      if (retryToggle) {
        retryToggle.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            openDrawer();
          },
          true
        );
      }
    }, 800);
  }
})();